/**
 * Main entry point of the React application
 * This file sets up the core application providers and configuration
 */

// React core imports
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// State management and data fetching
import { RecoilRoot } from "recoil"; // Global state management
import { QueryClientProvider } from "@tanstack/react-query"; // Data fetching and caching
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "core/queryClient";

// SEO and document head management
import { HelmetProvider } from "react-helmet-async";

import { KlaviyoService } from "services/klaviyo.service";

// Register Klaviyo service worker on page load (alongside main sw.js)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    KlaviyoService.registerServiceWorker().catch((err) =>
      console.warn("[Klaviyo SW] Registration failed:", err),
    );
  });
}

// Initialize React application by mounting to the root DOM element
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {" "}
    {/* Enable React strict mode for additional development checks */}
    <RecoilRoot>
      {" "}
      {/* Global state management provider */}
      <QueryClientProvider client={queryClient}>
        {" "}
        {/* React Query provider for data fetching */}
        <HelmetProvider>
          {" "}
          {/* Enable dynamic document head management */}
          <App />
        </HelmetProvider>
        {/* <ReactQueryDevtools initialIsOpen={true} /> */}{" "}
        {/* Development tools for React Query (currently disabled) */}
      </QueryClientProvider>
    </RecoilRoot>
  </StrictMode>,
);
